import React, { Component } from "react";

export default class CubeCountingSection extends Component {
  render() {
    var {
      cube_countring_score,
      cube_status_1,
      cube_status_2,
      cube_status_3,
      cube_status_4,
    } = this.props.data;
    return (
      <div className="row border border-dark bg-white">
        <div className="col-lg-12">
          <div className="row mt-4">
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>1) </b> 
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas/form-b/cube_counting/1.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>2) </b>
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas/form-b/cube_counting/2.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>3) </b> 
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas/form-b/cube_counting/3.png"}
                  alt="scorpion"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>4) </b> 
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={"./assets/images/ecas/form-b/cube_counting/4.png"}
                  alt="scorpion"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <br />
            <span className="fs-19">Score (0-4) </span>
            <input
              type="number"
              disabled
              name="cube_countring_score"
              value={cube_countring_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
